<div class="container side-filter">

            <div class='row'>
                <div class="col-12" id='filter-title' [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                    {{'filter.filter' | translate}}
                </div>
            </div>

<div class="row" style='padding-top:25px'>
    <div class="col-12">
        <div class="filterItem-container">

            <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl">

                  <mat-tree-node  *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>

                  <button mat-icon-button disabled></button>
                  <!-- <mat-icon class="type-icon" [attr.aria-label]="node.type + 'icon'">
                    {{ node.type ==='file' ? 'description' : 'folder' }}
                  </mat-icon> -->
                  <span class='node-name' [attr.class]='node.disabled?"disabled":""'>

                  <mat-checkbox  
                   [attr.class]='node.disabled?"disabled":""'
                  [checked]="checklistSelection.isSelected(node)"
                  (change)="todoLeafItemSelectionToggle(node)"
                  [disabled]='node.disabled'
                  *ngIf='node.name != "Roles"'  
                  > 
                  <!-- *ngIf="!node.disabled" -->

                  </mat-checkbox>
                  <span style='margin-left:10px' >
                    {{node.name }}
                 </span>  
                 </span>

                </mat-tree-node>
              
              
                <mat-tree-node  *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                  <button mat-icon-button matTreeNodeToggle style='background-color: transparent;border:0'
                          [attr.aria-label]="'toggle ' + node.name">
                    <mat-icon  class="mat-icon-rtl-mirror" style='color:#707070'>
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                  <!-- <mat-icon class="type-icon" [attr.aria-label]="node.type + 'icon'">
                    {{ node.type ==='file' ? 'description' : 'folder' }}
                  </mat-icon> -->
                  <span class='node-name' [attr.class]='node.disabled?"disabled":""'>
                    <mat-checkbox
                    *ngIf='node.name != "Roles"'  
                    [disabled]='node.disabled'
                    [checked]="descendantsAllSelected(node)"
                    [indeterminate]="descendantsPartiallySelected(node)"
                    (change)="todoItemSelectionToggle(node)"
                      class="checklist-leaf-node" >
                         
                           </mat-checkbox>
                           <span style='margin-left:10px' >
                            {{node.name}}
                         </span>  
                  </span>
                
                 
                </mat-tree-node>
              </mat-tree>
              

        </div>
    </div>
</div>

     

</div>